import React, { useState, useEffect, useContext } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { ScrollArea } from "../ui/scroll-area";
import { BASELINE } from "../../util";
import { UserContext } from '../../context/UserContext';
import axios from "axios";

const priorityColors = {
  low: "bg-blue-100 text-blue-800",
  medium: "bg-yellow-100 text-yellow-800",
  high: "bg-red-100 text-red-800",
};

const statusColors = {
  open: "bg-green-100 text-green-800",
  "in progress": "bg-purple-100 text-purple-800",
  closed: "bg-gray-100 text-gray-800",
};

export function MyTicketsView() {
  const { user } = useContext(UserContext);
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    if (user && user.u_id) {
      axios
        .get(`${BASELINE}getticket`, { params: { user_id: user.u_id } })
        .then(response => {
          if (response.data.success) {
            // Transform API data to the desired format:
            // { id, title, priority, status, date }
            const transformed = response.data.tickets.map(ticket => ({
              id: ticket.ticket_id,
              title: ticket.context
                ? ticket.context.substring(0, 30) + "..."
                : `Feedback Ticket #${ticket.ticket_id}`,
              priority: ticket.priority,
              status: ticket.status,
              date: new Date(ticket.created_time).toISOString().split('T')[0],
            }));
            setTickets(transformed);
          }
        })
        .catch(err => {
        });
    }
  }, [user]);

  return (
    <ScrollArea className="h-[calc(100vh-200px)]">
      <div className="space-y-4">
        {tickets.map((ticket) => (
          <Card key={ticket.id}>
            <CardHeader className="pb-2">
              <CardTitle className="text-lg">{ticket.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex justify-between items-center">
                <div className="space-x-2">
                  <Badge variant="secondary" className={priorityColors[ticket.priority]}>
                    {ticket.priority}
                  </Badge>
                  <Badge variant="secondary" className={statusColors[ticket.status]}>
                    {ticket.status}
                  </Badge>
                </div>
                <span className="text-sm text-muted-foreground">{ticket.date}</span>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </ScrollArea>
  );
}
